



class CartDrawer extends HTMLElement {
  constructor() {
    super();
      
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#head-cart-count');
    cartLink.setAttribute('role', 'button');

    if( window.location.pathname != routes_cart_url ){
        cartLink.setAttribute('aria-haspopup', 'dialog');
    
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');


    openProtectionPopupInDrawerCart()
    checkDoscuntLabelInAppTotalsDrawers();
   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

renderContents(parsedState) {
  this.querySelector('.drawer__inner')
    .classList.contains('is-empty') &&
    this.querySelector('.drawer__inner')
      .classList.remove('is-empty');

  this.productId = parsedState.id;

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    sectionElement.innerHTML =
      this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
  });

  openProtectionPopupInDrawerCart();
  getDataCart();
  promocodeSlideToggle();
  checkDoscuntLabelInAppTotalsDrawers();

  setTimeout(() => {
    this.querySelector('#CartDrawer-Overlay')
      .addEventListener('click', this.close.bind(this));

    this.open();
  });
}

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
      
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
      
  }

  setActiveElement(element) {
    this.activeElement = element;
    
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


 
// Show protection popup when clicked in cart drawer
function openProtectionPopupInDrawerCart() {
  const buttonsDrawerPopup = document.querySelectorAll(
    '.protection-btn-cart[data-popup]'
  );

  if (buttonsDrawerPopup.length === 0) return;

  buttonsDrawerPopup.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const popupFromDrawer = document.querySelector(
        `.protection-plan-popup[id="${this.dataset.popup}"]`
      );

      if (!popupFromDrawer) return;

      popupFromDrawer.classList.add('active');

      const parentCartItem = this.closest('.cart-item');

      const protectionForm = popupFromDrawer.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

      const popupQuantityInput = popupFromDrawer.querySelector(
        '.quantity__input[name="quantity"]'
      );

      const parentQuantityInput = parentCartItem?.querySelector(
        '.quantity__input'
      );

      if (popupQuantityInput && parentQuantityInput) {
        popupQuantityInput.value = parentQuantityInput.value;
      }

      if (protectionForm && parentCartItem) {
        const addOrUpdateProperty = (name, value) => {
          let input = protectionForm.querySelector(
            `input[name="${name}"]`
          );

          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            protectionForm.appendChild(input);
          }

          input.value = value || '';
        };

        addOrUpdateProperty(
          'properties[_protection_child]',
          'true'
        );

        addOrUpdateProperty(
          'properties[_protection_parent_key]',
          parentCartItem.dataset.key
        );

        addOrUpdateProperty(
          'properties[_protection_parent_product_id]',
          parentCartItem.dataset.productid
        );
      }
    });
  });

  if (
    document.querySelectorAll(
      '.cart-items .protection_plan_message'
    ).length > 0
  ) {
    document.querySelectorAll(
      '.cart-items .protection_plan_message'
    ).forEach((item) => {
      setTimeout(() => {
        item.style.display = 'block';
      }, 500);
    });
  }
}




  /*fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log(cart)
    })*/

     /* if(document.querySelectorAll('.cart-items .protection_plan_message').length > 0){
        document.querySelectorAll('.cart-items .protection_plan_message').forEach(item=>{
          setTimeout(function() {
             
              item.style.display = 'block';
          }, 500);
        })
      }*/




function applayDoscountAppButton(){
  setTimeout(() => {
    
    
      if(document.querySelectorAll('.docapp-coupon-input--bean-container--bean-remove').length > 0){
   
        document.querySelectorAll('.docapp-coupon-input--bean-container--bean-remove').forEach(item=>{
    
          item.addEventListener('click', function(){
        
            checkDoscuntLabelInAppTotalsDrawers()
          })
        })
      }

    },3000)

}applayDoscountAppButton()


function promocodeSlideToggle(){
  
  if(document.querySelectorAll('.js-promo-box-slide').length > 0){
    document.querySelector('.js-promo-box-slide').addEventListener('click', function(){
      this.classList.toggle('active');
    });
  }

  setTimeout(() => {
    

    if(document.querySelectorAll('.docapp-coupon-input--input-container .docapp-coupon-input--button').length > 0){
 
      document.querySelector('.docapp-coupon-input--input-container .docapp-coupon-input--button').addEventListener('click', function(){
        
        applayDoscountAppButton()
        checkDoscuntLabelInAppTotalsDrawers()
       
      })            
    }
  },1000)
  


}promocodeSlideToggle()



function checkDoscuntLabelInAppTotalsDrawers(){

  setTimeout(() => {
      if(document.querySelectorAll('.cart-drawer__footer .docapp-cart-with-coupon-summary--summary').length > 0){
            
            console.log('doctor discount app totals drawer')
            
              document.querySelector('.cart-drawer__footer .docapp-cart-with-coupon-summary--summary').classList.add('loaded-app')
              const summaryElement = document.querySelector('.cart-drawer__footer .docapp-cart-with-coupon-summary--summary');

                if (summaryElement.querySelector('.docapp-cart-discount')) {
                  summaryElement.classList.add('has-discount');
                  var totlasavingValue = summaryElement.querySelector('.docapp-cart-discount .docapp-right');
                  summaryElement.querySelector('.docapp-cart-discount .docapp-left').innerHTML = 'Total Savings';
                  totlasavingValue.textContent = totlasavingValue.textContent.replace('', '');
                } else {
                  summaryElement.classList.remove('has-discount');
                }


             

        }



  },3000)

}


function getDataCart(){

  fetch('/cart.js')
    .then(response => {
      return response.json();
    })
    .then(data => {
      //console.log('>>>>>>>>>>>>>>>>')
      console.log(data)
      
      getInnerProductsObjectsArray(data)
      
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}getDataCart()


function getInnerProductsObjectsArray(data) {
  const innerProducts = [];

  // Get parent purifier items that have inner subscription products
  data.items.forEach((item) => {
    if (item.properties && item.properties._inner_products) {
      let innerProductIds = [];

      try {
        innerProductIds = JSON.parse(item.properties._inner_products);
      } catch (e) {
        console.error('Invalid _inner_products JSON:', item.properties._inner_products);
      }

      innerProducts.push({
        parent_id: item.id,
        parent_key: item.key,
        bundle_uid: item.properties._subscription_bundle_uid || '',
        inner_products: innerProductIds
      });
    }
  });


  // Hide actual child subscription cart lines by cart line key
data.items.forEach((item) => {
  const isSubscriptionChild =
    item.properties?._subscription_child === 'true';

  const isProtectionChild =
    item.properties?._protection_child === 'true';

  if (isSubscriptionChild || isProtectionChild) {
    const childCartItem = document.querySelector(
      `.cart-items .cart-item[data-key="${CSS.escape(item.key)}"]`
    );

    if (childCartItem) {
      childCartItem.style.display = 'none';
    }
  }
});

 
// Build inner subscription products under the correct parent only
innerProducts.forEach((parent) => {
  const foundItems = data.items.filter((child) => {
    const matchesInnerProduct =
      parent.inner_products.some(
        (innerId) => Number(innerId) === Number(child.id)
      );

    if (!matchesInnerProduct) return false;

    const childBundleUid =
      child.properties?._subscription_bundle_uid || '';

    const isTaggedChild =
      child.properties?._subscription_child === 'true';

    // New bundle: only use children from the same bundle
    if (parent.bundle_uid) {
      return (
        isTaggedChild &&
        childBundleUid === parent.bundle_uid
      );
    }

    // Old bundle: only use untagged children
    return !isTaggedChild && !childBundleUid;
  });

    const innerProductsContainer = document.querySelectorAll(
      `.cart-items .cart-item[data-key="${CSS.escape(parent.parent_key)}"]`
    );

    if (innerProductsContainer.length > 0) {
      innerProductsContainer.forEach((container) => {
        if (!container.dataset.innerproducts) return;

        const fragmentElement = document.createDocumentFragment();

        foundItems.forEach((item) => {
          const innerProductDiv = document.createElement("div");
          innerProductDiv.classList.add("inner-product");
          innerProductDiv.classList.add("js-inner-product");
          innerProductDiv.setAttribute("data-key", item.key);
          innerProductDiv.setAttribute("data-id", item.id);

          innerProductDiv.innerHTML = `
            <div class="cart-inner-product-img">
              <img src="${item.featured_image?.url || ''}" width="80" alt="">
            </div>
            <div class="cart-inner-product-title-price">
              <div class="cart-inner-product-title">${item.product_title}</div>
                
              <div class="cart-inner-product-details">
                First payment $0, then <span>${item.selling_plan_allocation?.selling_plan?.name ?? ''}</span>
                <span class="cart-sale-price">${getProductJsDate(item.handle)}</span>
              </div>
              
              <div class="cart-inner-product-price">$${item.price}</div>
            </div>
            <div class="remove-element js-remove-inner-product" data-key="${item.key}">
              Remove
            </div>
          `;

          fragmentElement.appendChild(innerProductDiv);
        });

        const innerWrapper = container.querySelector('.js-inner-products');

        if (innerWrapper) {
          innerWrapper.innerHTML = '';
          innerWrapper.appendChild(fragmentElement);
        }
      });
    }
  });


// Display grouped protection plans inside their matching purifier cards
const protectionItems = data.items.filter((item) => {
  return item.properties?._protection_child === 'true';
});

const groupedProtectionItems = new Map();

protectionItems.forEach((protectionItem) => {
  const parentKey =
    protectionItem.properties?._protection_parent_key || '';

  const parentProductId =
    protectionItem.properties?._protection_parent_product_id || '';

  let parentCartItem = null;

  // First, use the exact purifier cart-line key
  if (parentKey) {
    parentCartItem = document.querySelector(
      `.cart-items .cart-item[data-key="${CSS.escape(parentKey)}"]`
    );
  }

  // If purifier lines joined, use product ID only when one parent line remains
  if (!parentCartItem && parentProductId) {
    const matchingParents = Array.from(
      document.querySelectorAll(
        `.cart-items .cart-item[data-productid="${CSS.escape(
          parentProductId
        )}"]:not([data-protection-child="true"]):not([data-subscription-child="true"])`
      )
    ).filter((cartItem) => {
      return cartItem.style.display !== 'none';
    });

    if (matchingParents.length === 1) {
      parentCartItem = matchingParents[0];
    }
  }

  if (!parentCartItem) return;

  const resolvedParentKey =
    parentCartItem.dataset.key || parentProductId;

  const protectionVariantId =
    protectionItem.variant_id || protectionItem.id;

  const groupKey =
    resolvedParentKey + '::' + protectionVariantId;

  if (!groupedProtectionItems.has(groupKey)) {
    groupedProtectionItems.set(groupKey, {
      parentCartItem,
      productTitle: protectionItem.product_title,
      variantTitle: protectionItem.variant_title || '',
      image: protectionItem.featured_image?.url || '',
      finalLinePrice: 0,
      quantity: 0,
      itemId: protectionItem.id,
      lineKeys: []
    });
  }

  const group = groupedProtectionItems.get(groupKey);

  group.finalLinePrice += Number(
    protectionItem.final_line_price || 0
  );

  group.quantity += Number(
    protectionItem.quantity || 1
  );

  group.lineKeys.push(protectionItem.key);
});

/*
 * Remove previously generated protection rows before rebuilding them.
 * getDataCart() can run more than once after cart updates.
 */
document.querySelectorAll(
  '.js-inner-products .js-inner-protection'
).forEach((protectionRow) => {
  protectionRow.remove();
});

groupedProtectionItems.forEach((group) => {
  const innerWrapper =
    group.parentCartItem.querySelector('.js-inner-products');

  if (!innerWrapper) return;

  const protectionDiv = document.createElement('div');

  protectionDiv.classList.add(
    'inner-product',
    'js-inner-product',
    'js-inner-protection'
  );

  protectionDiv.dataset.keys = group.lineKeys.join(',');
  protectionDiv.dataset.id = group.itemId;

  const protectionPrice =
    typeof Shopify !== 'undefined' &&
    typeof Shopify.formatMoney === 'function'
      ? Shopify.formatMoney(group.finalLinePrice)
      : `$${(group.finalLinePrice / 100).toFixed(2)}`;

  protectionDiv.innerHTML = `
    <div class="cart-inner-product-img">
      <img
        src="${group.image}"
        width="80"
        alt=""
      >
    </div>

    <div class="cart-inner-product-title-price">
      <div class="cart-inner-product-title">
        ${group.productTitle}
      </div>

      <div class="cart-inner-product-details">
        ${group.variantTitle}
      </div>

      <div class="cart-inner-product-price">
        ${protectionPrice}
      </div>
    </div>

    <div
      class="remove-element js-remove-inner-product"
      data-keys="${group.lineKeys.join(',')}"
    >
      Remove
    </div>
  `;

  innerWrapper.appendChild(protectionDiv);
});

  // Remove individual child subscription by cart line key, not variant ID
  const getInnerProductRemove =
  document.querySelectorAll('.js-remove-inner-product');

if (getInnerProductRemove.length > 0) {
  getInnerProductRemove.forEach((item) => {
    item.addEventListener('click', function(e) {
      e.preventDefault();

const lineKeys = (
  this.dataset.keys ||
  this.dataset.key ||
  ''
)
  .split(',')
  .map((key) => key.trim())
  .filter(Boolean);

const isProtectionPlan =
  this.classList.contains('js-inner-protection') ||
  this.closest('.js-inner-protection') !== null;

if (lineKeys.length === 0) return;

const updates = {};

lineKeys.forEach((lineKey) => {
  updates[lineKey] = 0;
});

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(
            'Could not remove the cart item'
          );
        }

this.closest('.js-inner-product')?.remove();

        return response.json();
      })
      .catch(error => {
        console.error('Remove item error:', error);
      })
      .finally(() => {
        cartItemCount();

        if (isProtectionPlan) {
          fetch(
            window.Shopify.routes.root +
            'cart?refresh=' +
            Date.now()
          )
          .then(response => response.text())
          .then(data => {
            const htmlContainer =
              document.createElement('div');

            htmlContainer.innerHTML = data;

            const newDrawerInner =
              htmlContainer.querySelector('.drawer__inner');

            const currentDrawerInner =
              document.querySelector('.drawer__inner');

            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML =
                newDrawerInner.innerHTML;
            }
          })
          .catch(error => {
            console.error(
              'Protection button refresh error:',
              error
            );
          })
          .finally(() => {
            getDataCart();
            openProtectionPopupInDrawerCart();
            promocodeSlideToggle();
            checkDoscuntLabelInAppTotalsDrawers();
          });
        } else {
          checkDoscuntLabelInAppTotalsDrawers();
        }
      });
    });
  });
}
}

function getProductJsDate(url) {
const bundleProducts = [
  {
    'bundle': 'parts-subscription-bundle-pre-filter',
    'price': '$35.99 <s>$39.99</s>',
  },
  {
    'bundle': 'parts-subscription-bundle-recharge-cell',
    'price': '$143.99 <s>$159.99</s>',
  },
  {
     'bundle': 'parts-subscription-bundle-core-750-lamp-kit',
      'price': '$35.99 <s>$39.99</s>',
    },
  {
      'bundle': 'parts-subscription-bundle-core-750-filter',
      'price': '$89.99 <s>$99.99</s>',
    }
  ]

return  (bundleProducts.find(item => item.bundle === url) || {}).price || '';

}


(function watchCartChangesAndRefreshDrawerOnly() {
  let lastCartSignature = null;
  let isRefreshingDrawer = false;

  

 function getCartSignature(cart) {
  return [
    cart.total_price,
    cart.total_discount
  ].join('::');
}

  function getCart() {
    return fetch('/cart.js')
      .then(response => response.json());
  }

  function refreshCartDrawerOnly() {
  return fetch(window.location.pathname + '?sections=cart-drawer')
    .then(response => response.json())
    .then(sections => {
      const html = sections['cart-drawer'];

      if (!html) return;

     const parser = new DOMParser();
const doc = parser.parseFromString(html, 'text/html');


/* Refresh top product title and prices for every parent item */
const newTopPrices = doc.querySelectorAll(
  '.cart-item:not([data-subscription-child="true"]) .drawer-item-heading'
);

const currentTopPrices = document.querySelectorAll(
  'cart-drawer .cart-item:not([data-subscription-child="true"]) .drawer-item-heading'
);

newTopPrices.forEach((newTopPrice, index) => {
  const currentTopPrice = currentTopPrices[index];

  if (newTopPrice && currentTopPrice) {
    currentTopPrice.replaceWith(newTopPrice);
  }
});

/* Refresh footer */
const newFooter = doc.querySelector('.cart-drawer__footer');
const currentFooter = document.querySelector(
  'cart-drawer .cart-drawer__footer'
);

if (newFooter && currentFooter) {
  currentFooter.replaceWith(newFooter);
}

if (typeof checkDoscuntLabelInAppTotalsDrawers === 'function') {
  checkDoscuntLabelInAppTotalsDrawers();
}
})
.catch(error => {
  console.error('Cart summary refresh error:', error);
});
}

  function checkCartForChanges() {
    if (isRefreshingDrawer) return;

    getCart()
      .then(cart => {
        const currentSignature = getCartSignature(cart);

        if (lastCartSignature === null) {
          lastCartSignature = currentSignature;
          return;
        }

        if (currentSignature !== lastCartSignature) {
          lastCartSignature = currentSignature;
          isRefreshingDrawer = true;

          console.log('Cart changed — refreshing drawer only');

          refreshCartDrawerOnly().finally(() => {
            setTimeout(() => {
              isRefreshingDrawer = false;
            }, 800);
          });
        }
      })
      .catch(error => {
        console.error('Cart watcher error:', error);
      });
  }

  setInterval(checkCartForChanges, 800);
})();